import Button from '@material-ui/core/Button';
import { fade, withStyles } from '@material-ui/core/styles';

export const SoftButton = withStyles(({ palette, spacing }) => ({
  root: (props: { size?: 'small' | 'medium' | 'large' }) => {
    const paddingBySize = {
      small: spacing(0.5, 1.25),
      medium: spacing(0.75, 2),
      large: spacing(1, 2.75)
    };

    const padding = paddingBySize[props.size || 'medium'];

    return {
      position: 'relative',
      padding,
      overflow: 'hidden',

      color:
        palette.type === 'light' ? palette.primary.main : palette.primary.light,
      backgroundColor: fade(palette.primary.main, 0.2),
      '&:hover, &.Mui-focusVisible': {
        backgroundColor: fade(palette.primary.main, 0.3)
      },

      '&.Mui-disabled': {
        color: palette.action.disabled,
        backgroundColor: palette.action.disabledBackground
      },

      '&:not(.Mui-disabled)::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: palette.background.paper,
        zIndex: -1
      }
    };
  }
}))(Button);
